import moment from 'moment';
import React, { useRef, useState } from 'react';
import { MenuItem } from '../../../../components/MenuItem';
import { Text } from '../../../../components/Text';
import { FocusPosition, RangeIndex } from '../../types';

export const useTimeOptions = (
  time: string,
  setOpen: (v: boolean) => void,
  onChange: (time: string) => void,
  rangeKey: RangeIndex,
  positionKey: FocusPosition,
) => {
  const [highlighted, setHighlighted] = useState<string | null>(time);
  const timeOptions = getTimeOptions().map((timeOption, index) => ({
    timeOption,
    menuItem: (
      <MenuItem
        key={`${rangeKey}-${positionKey}-${timeOption}-timeOption`}
        ref={item => (timeOptionRefs.current[index] = item)}
        onClick={() => {
          onChange(timeOption);
          setOpen(false);
        }}
        highlighted={highlighted === timeOption}
        onMouseEnter={() => setHighlighted(timeOption)}
        onMouseLeave={() => setHighlighted(time)}
      >
        <Text appearance="bodyMedium" tag="div">
          {timeOption}
        </Text>
      </MenuItem>
    ),
  }));
  const timeOptionRefs = useRef(Array(timeOptions.length).fill(null));

  return {
    timeOptions,
    timeOptionRefs,
  };
};

// generate time options starting at 12:00 AM and ending at 11:45 PM in 15 minute increments
function getTimeOptions(): string[] {
  // pre-allocate an array of time options with 96 slots (24 hours * 4 quarters)
  const arr: string[] = Array.from({ length: 96 });

  // Adjust to the nearest past quarter hour
  const midnight = moment().startOf('day');
  for (let i = 0; i < arr.length; i++) {
    arr[i] = midnight.format('hh:mm A');
    midnight.add(15, 'minutes');
  }

  return arr;
}
